var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.processStartHandle()}}},[_vm._v(_vm._s(_vm.$t('process.createInstance')))])
}
var staticRenderFns = []

export { render, staticRenderFns }